import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Leaf, Loader2, MailCheck, ArrowLeft } from "lucide-react";

export default function GlomtLosenord() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      // Läck aldrig – visa alltid samma bekräftelse.
      setSent(true);
    } finally { setLoading(false); }
  };

  return (
    <div className="hamn-bg min-h-screen flex items-center justify-center p-6">
      <Card className="w-full max-w-md rounded-2xl border-border p-8 md:p-10">
        <div className="flex items-center gap-2 mb-6">
          <div className="h-9 w-9 rounded-lg bg-primary flex items-center justify-center text-primary-foreground"><Leaf className="h-5 w-5" /></div>
          <span className="font-head font-bold text-primary text-lg">HAMN CV Studio</span>
        </div>
        {sent ? (
          <div className="text-center space-y-3" data-testid="forgot-sent">
            <MailCheck className="h-10 w-10 text-primary mx-auto" />
            <h1 className="font-head text-2xl font-bold">Kolla din inkorg</h1>
            <p className="text-sm text-muted-foreground">Om adressen finns hos oss har vi skickat en återställningslänk. Länken gäller i 30 minuter.</p>
            <Link to="/login"><Button variant="outline" className="rounded-full mt-2"><ArrowLeft className="h-4 w-4 mr-2" /> Tillbaka till inloggning</Button></Link>
          </div>
        ) : (
          <>
            <h1 className="font-head text-3xl font-bold">Glömt lösenord?</h1>
            <p className="text-muted-foreground mt-2 mb-6">Ange din e-postadress så skickar vi en länk för att välja ett nytt lösenord.</p>
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">E-post</Label>
                <Input data-testid="forgot-email-input" id="email" type="email" required value={email}
                  onChange={(e) => setEmail(e.target.value)} placeholder="namn@exempel.se" />
              </div>
              <Button data-testid="forgot-submit-btn" type="submit" className="w-full rounded-full h-11" disabled={loading}>
                {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Skicka återställningslänk
              </Button>
            </form>
            <p className="text-sm text-muted-foreground mt-6 text-center">
              <Link to="/login" className="text-primary font-medium hover:underline">Tillbaka till inloggning</Link>
            </p>
          </>
        )}
      </Card>
    </div>
  );
}
